export const PENDING_PROMPT_KEY = "basiq_pending_prompt";
export const AUTH_TAB_KEY = "basiq_auth_tab";

export const peekAuthTab = () => {
  try { return sessionStorage.getItem(AUTH_TAB_KEY) || "login"; } catch { return "login"; }
};

export const clearAuthTab = () => {
  try { sessionStorage.removeItem(AUTH_TAB_KEY); } catch {}
};

// Stores an optional prompt then redirects to Google login.
export const startGoogleLogin = (pendingPrompt) => {
  try {
    if (pendingPrompt && pendingPrompt.trim()) {
      localStorage.setItem(PENDING_PROMPT_KEY, pendingPrompt.trim());
    }
  } catch {}
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

// Landing lives on another subdomain: it hands the hero prompt over via ?prompt=...
export const capturePromptFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const p = (params.get("prompt") || "").trim();
    const auth = params.get("auth");
    if (!p && !auth) return;
    if (p) localStorage.setItem(PENDING_PROMPT_KEY, p);
    if (auth === "register" || auth === "login") sessionStorage.setItem(AUTH_TAB_KEY, auth);
    params.delete("prompt");
    params.delete("auth");
    const qs = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash);
  } catch {}
};

export const getPendingPrompt = () => {
  try { return localStorage.getItem(PENDING_PROMPT_KEY) || null; } catch { return null; }
};

export const clearPendingPrompt = () => {
  try { localStorage.removeItem(PENDING_PROMPT_KEY); } catch {}
};
